export class RowParser {
  constructor() {
    this.init(null);
  }

  init(row) {
    this.row = row;
    this.jsonDepth = 0;
    this.currentStr = '';
    this.lines = [];
  }

  parse(row) {
    this.init(row);
    for (let i = 0; i < this.row.length; i++) {
      const char = this.row.charAt(i);

      switch (char) {
        case '{':
          this.jsonDepth += 1;
          this.currentStr += char;
          break;
        case '}':
          this.jsonDepth -= 1;
          this.currentStr += char;
          if (this.jsonDepth === 0) {
            this.lines.push(this.currentStr);
            this.currentStr = '';
          }
          break;
        default:
          this.currentStr += char;
          break;
      }
    }
    return {lines: this.lines, rest: this.currentStr};
  }
}
